import Translation from '../../state/state-types/TranslationStateType'

export const checkFirstName = (name: string, translation: Translation) => {
    if (name.length < 2) {
        return translation.validation.firstNameCannotBeShorter
    } else if (name.length > 26) {
        return translation.validation.firstNameCannotBeLonger
    } else {
        return ''
    }
}
